import axios from 'axios';
import { FETCH_LIST } from './types';
import api from '../../../utils/api';

const _pendingActions = {};

export default {
  async fetchList({ commit, state }) {
    if (state.items && state.items.length) return;
    if (_pendingActions.fetchList) return _pendingActions.fetchList;
    _pendingActions.fetchList = (async () => {
      try {
        const response = await axios(api.tags.fetch());
        commit(FETCH_LIST, { items: response.data.results });
      } finally {
        delete _pendingActions.fetchList;
      }
    })();
    return _pendingActions.fetchList;
  },
  async tagRecommendation(_, addTags) {
    await axios(api.tags.create(addTags));
  },
  async createTag(_, tags) {
    const { data } = await axios(api.tags.newTag(tags));
    return data;
  },
  async createTags(_, tags) {
    const { data } = await axios(api.tags.createTags(tags));
    return data;
  },
};
